import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import ButtonDiff from './PropertiesPaneButtonDiff.jsx'
import Model from './ModelIsrfreq.mjs'
import ReqType from './ReqType.jsx'
import useModuleType from './useModuleType.mjs'

export default function PropertiesPaneIsrfreq(props) {
    const ModuleType = useModuleType()

    return (
        <ComponentPropertiesPane
            buttons={<ButtonDiff />}
            controllers={
                <>
                    <Text prop="reqTitle" />
                    <Select prop="reqType" options={ReqType} />
                    <Select prop="moduleType" options={ModuleType} />
                    <LongText prop="memo" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'Effect',
                    ]}
                />
            }

            {...props}
        />
    )
}
